import axios from "axios";
import Swal from "sweetalert2";

export const getAllActiveEmployees = async () => {
    try {
        const response = await axios.get("/employees");
        return response.data
    } catch (error) {
        console.log(error)
        showWarning('Failed to fetch allowance');
    }
}

const showWarning = (str) => {
    return Swal.fire({
        title: "Error",
        text: str,
        icon: "error",
    });
}


export const getSearchEmployees = async ({name, epf_number, status, startDate, endDate, departmentName, employee_type, designation, page, limit, setLoading}) => {
    try {
        if (setLoading) setLoading(true);
        
        const response = await axios.post(`/employees-search`, {
                name: name,
                epf_number: epf_number,
                status,
                startDate,
                endDate,
                departmentName,
                employee_type,
                designation,
                page: page || 1,
                limit: limit || 10
            }
        );

        if (setLoading) setLoading(false);
        console.log("search with pagination:", response);
        return response.data;
        
    } catch (error) {
        if (setLoading) setLoading(false);
        console.log(error);
        return { data: [] };
    }
};